var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.localizationFromLegacy)?_c('div',[_c('p',{domProps:{"innerHTML":_vm._s(_vm.localizationFromLegacy)}})]):_c('div',[_c('p',{domProps:{"innerHTML":_vm._s(_vm.streetAddress)}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.cityAddress)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b047c90","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/packs/shared/components/full_address.vue
// module id = 660
// module chunks = 0 1 2 3 4 5 6 7 8 10 18 162 209 353